'use client';

import { getConsent, onConsentChange } from './consent';
import { useEffect, useSyncExternalStore } from 'react';
import { usePathname } from 'next/navigation';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    __lapidsConsentBootstrapped?: boolean;
  }
}

type GoogleTagConsentUpdaterProps = {
  id?: string | null;
};

export function GoogleTagConsentUpdater(
  props: Readonly<GoogleTagConsentUpdaterProps>,
) {
  void props.id;
  return <GoogleTagConsentUpdaterInner />;
}

function GoogleTagConsentUpdaterInner() {
  const pathname = usePathname();
  const consent = useSyncExternalStore(
    (listener) => onConsentChange(() => listener()),
    () => getConsent(),
    () => null,
  );
  const isConversionPage = pathname === '/thank-you';

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      typeof window.gtag !== 'function' ||
      consent === null
    ) {
      return;
    }

    if (window.__lapidsConsentBootstrapped) {
      window.__lapidsConsentBootstrapped = false;
      return;
    }

    const nextAnalytics = consent.analytics || isConversionPage;
    const nextAds = consent.ads;

    window.gtag('consent', 'update', {
      analytics_storage: nextAnalytics ? 'granted' : 'denied',
      ad_storage: nextAds ? 'granted' : 'denied',
      ad_user_data: nextAds ? 'granted' : 'denied',
      ad_personalization: nextAds ? 'granted' : 'denied',
    });
  }, [consent, isConversionPage]);

  return null;
}
